import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Helmet from "react-helmet";
import headersList from "Constants/headersList";
import get from "lodash/get";
import { withSnackbar } from "notistack";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import { bindActionCreators } from "redux";
import emptylist from "Assets/Svg/illustration-no-policy.svg";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import { instance } from "../../../../../Actions/AxiosInstance";
import {
  CheckActionPermission,
  CommonReducerAction,
  ExtraTimeData,
  GetAllExtraTime,
  setHelperText,
} from "../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../Actions/LanguageAction";
import CreateExtraTimeImage from "../../../../../Assets/Images/time_management.svg";
import PageNotFound from "../../../../../Component/NotFound/index";
import Stepper from "../../../../../Component/Stepper";
import { ApiReducerType, ReducersTypes } from "../../../../../Constants";
import {
  CreateComp,
  List,
  TDTypeConsts,
} from "../../../business-configration/commons";
import ExtraTimePolicy from "./ExtraTimePolicy";
import NameDesc from "./NameDesc";
import NonWorkingDay from "./NonWorkingDay";
import Preview from "./Preview";
import WorkingDay from "./WorkingDay";

// import Done from "@material-ui/icons/Done";
// import DoneAllIcon from "@material-ui/icons/DoneAll";
// import DeleteIcon from './../../../../../Assets/Icons/DeleteIcon.svg';

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {},
});

class ExtraTime extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      actionidList: "",
      value: 0,
      currentRoute: "list",
      parentid: null,
      completed: {},
      Breadcrums: ["Track", "Attendance", "Extra Time"],
      headers: [
        {
          key: "extratimepolicyname",
          name: (
            <FormattedMessage
              id="LbExtraTimeName"
              defaultMessage="Extra Time Name"
            />
          ),
          type: TDTypeConsts.EDIT_NAME,
          style: { textAlign: "left" },
        },
        {
          key: "addedbyimagepath",
          name: (
            <FormattedMessage id="LbCreatedBy" defaultMessage="Created By" />
          ),
          type: TDTypeConsts.CREATED_BY,
        },
        {
          key: "assignedEmployeeList",
          name: (
            <FormattedMessage
              id="LbAssignedEmployee"
              defaultMessage="Assigned Employee"
            />
          ),
          type: TDTypeConsts.ASSIGNED_USER,
          style: { padding: "0" },
        },
        {
          key: "policystatus",
          name: (
            <FormattedMessage
              id="LbExtraTimeStatus"
              defaultMessage="Extra Time Status"
            />
          ),
          type: TDTypeConsts.EXTRA_TIME_STATUS,
        },
      ],
      AllStep: [
        {
          step: 1,
          component: (
            <NameDesc
              onRef={(ref) =>
                this.setState({
                  child0: {
                    ...ref,
                    onCancel: this.cancel,
                    onSaveDraft: this.onSaveDraft,
                  },
                })
              }
              StepError={this.StepError.bind(this)}
              click={this.onClick}
            />
          ), // handleStep={this.handleStep}
          label: <FormattedMessage id="LbDescribe" defaultMessage="Describe" />,
          isError: false,
        },
        {
          step: 2,
          component: (
            <WorkingDay
              onRef={(ref) =>
                this.setState({
                  child1: {
                    ...ref,
                    onCancel: this.cancel,
                    onSaveDraft: this.onSaveDraft,
                    onPrev: this.onPrevClick,
                  },
                })
              }
              StepError={this.StepError.bind(this)}
              click={this.onClick}
            />
          ),
          label: "Working Day Benefits",
          isError: false,
        },
        {
          step: 3,
          component: (
            <NonWorkingDay
              onRef={(ref) =>
                this.setState({
                  child2: {
                    ...ref,
                    onCancel: this.cancel,
                    onSaveDraft: this.onSaveDraft,
                    onPrev: this.onPrevClick,
                  },
                })
              }
              StepError={this.StepError.bind(this)}
              click={this.onClick}
            />
          ),
          label: "Non-Working Day Benefits",
          isError: false,
        },
        {
          step: 4,
          component: (
            <ExtraTimePolicy
              onRef={(ref) =>
                this.setState({
                  child3: {
                    ...ref,
                    onCancel: this.cancel,
                    onSaveDraft: this.onSaveDraft,
                    onPrev: this.onPrevClick,
                  },
                })
              }
              StepError={this.StepError.bind(this)}
              click={this.onClick}
            />
          ),
          label: "Extra Time Policy",
          isError: false,
        },
        {
          step: 5,
          component: (
            <Preview
              onRef={(ref) =>
                this.setState({
                  child4: {
                    ...ref,
                    onCancel: this.cancel,
                    onSaveDraft: this.onSaveDraft,
                    onNext: this.save,
                    onPrev: this.onPrevClick,
                  },
                })
              }
            />
          ),
          label: "Preview",
        },
      ],
      editPre: true,
      permissions: { readOnly: false, editable: false },
    };
  }

  componentWillMount() {
    this.props.history.push(`${this.props.match.path}/list`);
    this.props.ChangeLanguage("extratimepolicy,navigation");
  }

  setHelperText = (key) => {
    this.props.setHelperText({ helperText: key });
  };

  componentWillUnmount() {
    this.props.CommonReducerAction(`${ApiReducerType.EXTRA_TIME}_PENDING`);
    this.props.CommonReducerAction(`${ReducersTypes.LANGUAGE}_PENDING`);
    this.setHelperText("");
  }

  componentDidMount() {
    const [isTrue, permissions] = CheckActionPermission("extratime");
    if (isTrue) {
      this.setState({ permissions }, () => {
        //    if (!this.state.actionidList.includes(3)) {
        //        let index = this.state.headers.findIndex(x => x.type == TDTypeConsts.EDIT_WITHOUT_HEADER)
        //        if (index != -1) {
        //            this.headers.splice(index, 1)
        //        }
        //    }
        //    if (!this.state.actionidList.includes(4)) {
        //        let index = this.state.headers.findIndex(x => x.type == TDTypeConsts.IS_ACTIVE)
        //        if (index != -1) {
        //            this.headers.splice(index, 1)
        //        }
        //    }
      });
    } else {
      this.setState({ permissiondenied: true });
    }

    // const [isTrue, actionlistObject] = CheckActionPermission(this.props.history.location.pathname)
    // if (isTrue) {
    //     this.setState({ actionidList: "1,2,3,4" }, () => {
    // actionlistObject.actionidlist }, () => {
    const verObject = {
      key: "versioncount",
      name: <FormattedMessage id="LbVersions" defaultMessage="Versions" />,
      type: TDTypeConsts.VERSIONS,
    };
    this.state.headers.push(verObject);
    if (
      this.props.history.location.pathname.includes("versions") ||
      this.props.history.location.pathname.includes("view")
    ) {
      this.props.history.push(`${this.props.match.path}/list`);
      this.setState({ currentRoute: "list", parentid: null }, () => {
        this.props.GetAllExtraTime("attendance/allextratimepolicybysubid/1");
        // setTimeout(() => {
        //     if (this.props.EXTRA_TIME.Data.length == 0) {
        //         this.props.GetAllExtraTime('attendance/allextratimepolicybysubid/2')
        //         this.handleChange(null, 1)
        //     }
        //     else {
        // this.handleChange(null, 0)
        //     }
        // }, 1500)
      });
    } else if (this.props.history.location.pathname.includes("list")) {
      this.props.CommonReducerAction(ReducersTypes.CLEAREXTRATIMEDATA);
      this.props.GetAllExtraTime("attendance/allextratimepolicybysubid/1");
      // setTimeout(() => {
      //     if (this.props.EXTRA_TIME.Data.length == 0) {
      //         this.props.GetAllExtraTime('attendance/allextratimepolicybysubid/2')
      //         this.handleChange(null, 1)
      //     } else {
      // this.handleChange(null, 0)
      //     }
      // }, 1500)
    } else {
      // thing on create
      this.props.CommonReducerAction(ReducersTypes.CLEAREXTRATIMEDATA);
    }
    //    if (!this.state.actionidList.includes(3)) {
    //        let index = this.headers.findIndex(x => x.type == TDTypeConsts.EDIT_WITHOUT_HEADER)
    //        if (index != -1) {
    //            this.headers.splice(index, 1)
    //        }
    //    }
    //    if (!this.state.actionidList.includes(4)) {
    //        let index = this.headers.findIndex(x => x.type == TDTypeConsts.IS_ACTIVE)
    //        if (index != -1) {
    //            this.headers.splice(index, 1)
    //        }
    //    }
    // })
    // } else {
    //     // this.props.history.push('404')
    // }
  }

  componentWillReceiveProps(props) {
    if (!props.history.location.pathname.includes(this.state.currentRoute)) {
      if (props.history.location.pathname.includes("list")) {
        // this.state.currentRoute = "list";
        // this.props.CommonReducerAction(ReducersTypes.CLEAREXTRATIMEDATA);

        this.state.Breadcrums.splice(3);
        // this.state.headers[0].type = TDTypeConsts.EDIT_NAME;
        let status;
        this.state.value == 0
          ? (status = 1)
          : this.state.value == 1
          ? (status = 2)
          : (status = 0);
        this.props.GetAllExtraTime(
          `attendance/allextratimepolicybysubid/${status}`,
        );
        if (this.state.parentid) {
          let index = this.state.headers.findIndex((x) => x.key == "version");
          this.state.headers.splice(index, 1);
          index = this.state.headers.findIndex((x) => x.key == "policystatus");
          this.state.headers.splice(index, 1);
          this.state.headers.push(
            {
              key: "assignedEmployeeList",
              name: (
                <FormattedMessage
                  id="LbAssignedUser"
                  defaultMessage="Assigned User"
                />
              ),
              type: TDTypeConsts.ASSIGNED_USER,
              style: { padding: "0" },
            },
            {
              key: "policystatus",
              name: (
                <FormattedMessage
                  id="LbExtraTimeStatus"
                  defaultMessage="Extra Time Status"
                />
              ),
              type: TDTypeConsts.EXTRA_TIME_STATUS,
            },
            {
              key: "versioncount",
              name: (
                <FormattedMessage id="LbVersions" defaultMessage="Versions" />
              ),
              type: TDTypeConsts.VERSIONS,
            },
          );
          this.setState({ parentid: null, currentRoute: "/list" });
        }
      } else if (props.history.location.pathname.includes("versions")) {
        this.state.Breadcrums.splice(3, 1, "Versions");
        this.setState(
          { Breadcrums: this.state.Breadcrums, currentRoute: "versions" },
          () => {
            if (!this.state.parentid) {
              this.props.history.push(`${this.props.match.path}/list`);
            }
            const verObject = {
              key: "version",
              name: "Version",
              type: TDTypeConsts.OTHERS,
            };
            const index = this.state.headers.findIndex(
              (x) => x.key == "versioncount",
            );
            this.state.headers.splice(index, 1);
            const indexlist = this.state.headers.findIndex(
              (x) => x.key == "assignedEmployeeList",
            );
            this.state.headers.splice(indexlist, 1);
            this.state.headers.push(verObject);
            // this.state.headers[0].type = TDTypeConsts.EXTRA_TIME_NAME;
            this.props.GetAllExtraTime(
              `/attendance/extratimebyparentid/${this.state.parentid}`,
            );
          },
        );
        // } else if (props.history.location.pathname.includes('create')) {
        //     if (this.state.currentRoute != "create") {
        //         this.setState({ currentRoute: "create" })
        //     }
        // }
      } else if (props.history.location.pathname.includes("view")) {
        this.setState({ currentRoute: "view" });
      } else if (props.history.location.pathname.includes("create")) {
        this.setState({ currentRoute: "create" });
      } else if (props.match.path != "/config/track/attendance/extra_time") {
        this.props.history.push(`${this.props.match.path}/list`);
      }
    }
    if (
      props.history.location.pathname.includes("create") &&
      this.props.extraTimeDataReducer.extratimepolicyname &&
      this.props.extraTimeDataReducer.extratimepolicyname != ""
    ) {
      this.state.Breadcrums.splice(
        3,
        1,
        this.props.extraTimeDataReducer.extratimepolicyname,
      );
      // this.setState({ Breadcrums: this.state.Breadcrums })
      if (this.props.extraTimeDataReducer.extratimepolicyname) {
        this.state.Breadcrums.splice(
          3,
          1,
          this.props.extraTimeDataReducer.extratimepolicyname,
        );
        this.setState({
          currentRoute: "create",
          Breadcrums: this.state.Breadcrums,
        });
      }
    }
  }

  handleChange = (event, value) => {
    if (this.state.value == value) return false;

    let status;
    value == 0 ? (status = 1) : value == 1 ? (status = 2) : (status = 0);
    this.props.GetAllExtraTime(
      `attendance/allextratimepolicybysubid/${status}`,
    );
    this.setState({ value }, () => {
      switch (this.state.value) {
        case 0:
          {
            const index = this.state.headers.findIndex(
              (x) => x.key == "version",
            );
            this.state.headers.splice(index, 1);
            this.state.headers.splice(2, 0, {
              key: "assignedEmployeeList",
              name: (
                <FormattedMessage
                  id="LbAssignedUser"
                  defaultMessage="Assigned User"
                />
              ),
              type: TDTypeConsts.ASSIGNED_USER,
              style: { padding: "0" },
            });
            this.state.headers.push(
              {
                key: "policystatus",
                name: (
                  <FormattedMessage
                    id="LbExtraTimeStatus"
                    defaultMessage="Extra Time Status"
                  />
                ),
                type: TDTypeConsts.EXTRA_TIME_STATUS,
              },
              {
                key: "versioncount",
                name: (
                  <FormattedMessage id="LbVersions" defaultMessage="Versions" />
                ),
                type: TDTypeConsts.VERSIONS,
              },
            );
          }
          break;
        case 1: {
          this.state.headers.splice(
            this.state.headers.findIndex((x) => x.key == "versioncount"),
            1,
          );
          this.state.headers.splice(
            this.state.headers.findIndex(
              (x) => x.key == "assignedEmployeeList",
            ),
            1,
          );
          break;
        }
        default:
          break;
      }
    });
  };

  onClick = () => {
    this.child.handleNext();
  };

  // handleStep = (step) => {
  //     this.child.handleStep(step)
  // }
  save = (isdraft = false) => {
    const { extraTimeDataReducer } = this.props;
    const index = this.state.AllStep.map((item) => item.isError).findIndex(
      (x) => x == true,
    );
    if (index >= 0) {
      this.props.enqueueSnackbar("Please resolve all errors", {
        variant: "error",
      });
      return false;
    }
    if (
      !extraTimeDataReducer.extratimepolicyname ||
      extraTimeDataReducer.extratimepolicyname == ""
    ) {
      this.props.enqueueSnackbar("Please add policy name", {
        variant: "error",
      });
      return false;
    }
    if (!isdraft) {
      this.props.CommonReducerAction(ReducersTypes.CLEAREXTRATIMEDATA);
      const { Breadcrums } = this.state;
      if (Breadcrums.length > 3) {
        Breadcrums.splice(3);
        this.setState({ Breadcrums });
      }
    }

    // if (extraTimeDataReducer.extratimepolicyname != "")
    extraTimeDataReducer.isdraft = isdraft === true ? true : false;
    instance
      .post("/attendance/insertupdateextratimepolicy", extraTimeDataReducer)
      .then((result) => {
        this.props.enqueueSnackbar("Extra Time Policy Saved Successfully", {
          variant: "success",
        });
        if (!isdraft) {
          // let Breadcrums = this.state.Breadcrums
          // Breadcrums.splice(3)
          // this.setState({ activeStep: 0, completed: {} }, () => {
          //     this.handleChange(null, 0)
          //     this.props.history.push(`${this.props.match.path}/list`)
          //     this.props.GetAllExtraTime('attendance/allextratimepolicybysubid/1')
          //     // this.props.CommonReducerAction(ReducersTypes.CLEAREXTRATIMEDATA)
          // })
          const AllStep = get(this.state, "AllStep", []).map((x) => ({
            ...x,
            isError: false,
          }));

          this.setState({ activeStep: 0, completed: {}, AllStep });
          let status;
          this.state.value == 0
            ? (status = 1)
            : this.state.value == 1
            ? (status = 2)
            : (status = 0);
          this.props.GetAllExtraTime(
            `attendance/allextratimepolicybysubid/${status}`,
          );
          this.handleChange(null, 0);
        } else {
          this.props.ExtraTimeData({
            ...extraTimeDataReducer,
            extratimepolicyid: result.data.result[0].extratimepolicyid,
          });
          let status;
          this.state.value == 0
            ? (status = 1)
            : this.state.value == 1
            ? (status = 2)
            : (status = 0);
          this.props.GetAllExtraTime(
            `attendance/allextratimepolicybysubid/${status}`,
          );
        }
        this.props.history.push(`${this.props.match.path}`);
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  };

  cancel = () => {
    if (this.props.location.pathname.includes("/versions")) {
      this.props.history.push(`${this.props.match.path}/list`);
    } else {
      this.props.history.push(`${this.props.match.path}`);
    }
  };

  _cancel = () => {
    this.props.history.push(`${this.props.match.path}/list`);
    for (const step of this.state.AllStep) {
      step.isError = false;
    }
    const { Breadcrums } = this.state;
    if (Breadcrums.length > 3) {
      Breadcrums.splice(3);
      this.setState({ Breadcrums });
    }
    this.setState({ Breadcrums, AllStep: this.state.AllStep }, () => {
      // this.props.history.push(`${this.props.match.path}/list`)
      this.props.CommonReducerAction(ReducersTypes.CLEAREXTRATIMEDATA);
    });
  };

  StepError(step, error) {
    const index = this.state.AllStep.findIndex((x) => x.step == step);
    const { AllStep } = this.state;
    AllStep[index].isError = error;
    this.setState({ AllStep });
  }

  _onCreate = () => {
    const { match } = this.props;
    this.props.CommonReducerAction(ReducersTypes.CLEAREXTRATIMEDATA);
    this.props.history.push(`${match.path}/create`);
    const AllStep = get(this.state, "AllStep", []).map((x) => ({
      ...x,
      isError: false,
    }));
    // for (const AllStep of this.state.AllStep) {
    //   AllStep.isError = false;
    // }
    this.setState({ completed: {}, AllStep });
  };

  // DeleteHolidayPlan() {
  //   const HolidayInfo = this.props.holidayPlanReducer;
  //   const URL = `leaves/deleteholidayplan/${HolidayInfo.holidayplanid}/${HolidayInfo.holidayyear}`;
  //   instance
  //     .delete(URL)
  //     .then(() => {
  //       this.props.enqueueSnackbar("Holiday plan deleted successfully", {
  //         variant: "success",
  //       });
  //       this.OnCancel();
  //     })
  //     .catch((error) => {
  //       const CommonError = error.response
  //         ? error.response.data.error.message
  //         : error.message;
  //       this.props.enqueueSnackbar(CommonError, { variant: "error" });
  //     });
  // }

  _onDelete = () => {
    const { extraTimeDataReducer } = this.props;
    instance
      .delete(
        `/attendance/extratimepolicy/${extraTimeDataReducer.extratimepolicyid}`,
      )
      .then(() => {
        this.props.enqueueSnackbar("Extra Time Policy Deleted Successfully", {
          variant: "success",
        });

        // this.setState({ activeStep: 0, completed: {} });
        // this.handleChange(null, 0);
        // this.props.history.push(`${this.props.match.path}/list`);
        // this.props.GetAllExtraTime("attendance/allextratimepolicybysubid/1");
        this.cancel();
        this.props.GetAllExtraTime("attendance/allextratimepolicybysubid/1");
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  };

  getText() {
    return (
      <span>
        {this.state.value == 0 ? (
          <span>
            <FormattedMessage
              id="extraTimeConcept"
              defaultMessage="Often, when employees work beyond their stipulated work-hours or on non-working days (holidays/weekly-offs), they expect some kind of compensation in exchange for the extra efforts. Of course, some companies may have a culture which doesn't warrant it."
            />
            <br></br>
            <br></br>
            <FormattedMessage
              id="extraTimeConceptSub"
              defaultMessage="But if your company wishes to offer such compensation, you can use this Extra Time feature to define how should we treat extra-time hours of an employee, if she works over-time or on non-working days - you can choose to pay or offer compensatory-offs in exchange for the extra-time attendance."
            />
            {/* {createstore.getState().SubscriptionInfo.SubscriptionData.subscriptionname} */}
          </span>
        ) : (
          <span>
            Saved drafts allow you to store policies that you have not finished
            creating.
          </span>
        )}
      </span>
    );
  }

  setStep(step, completed) {
    this.setState({ activeStep: step, completed });
  }

  onSaveDraft = () => {
    this.save(true);
  };

  onPrevClick = () => {
    this.child.handleBack();
  };

  _renderForm = () => {
    const { child0, child1, child2, child3, child4 } = this.state;
    const canSaveAsDraft =
      get(this.props, "extraTimeDataReducer.isdraft", "") === true ||
      !get(this.props, "extraTimeDataReducer.extratimepolicyid", "");
    const stepperchilds = [child0, child1, child2, child3, child4].filter(
      (x) => x,
    );
    !canSaveAsDraft &&
      [...stepperchilds].map((x) => {
        delete x.onSaveDraft;
        return x;
      });

    return (
      <div className="content-outer-wrapper">
        <Stepper
          AllStep={this.state.AllStep}
          onRef={(ref) => (this.child = ref)}
          setStep={this.setStep.bind(this)}
          completed={this.state.completed}
          childs={[child0, child1, child2, child3, child4]}
        />
        {/* <div className="draftbutton-wrapper">
        <div className="draftclosebutton1" onClick={() => this.cancel()}>
          <span className="floatleft" style={{ marginLeft: 6 }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
              <path d="M0 0h24v24H0z" fill="none" />
            </svg>
          </span>
          <span className="draftclosebutton-text">Close</span>
        </div>
        {this.state.activeStep == this.state.AllStep.length - 1 ? (
          <div
            className="draftbutton-innerwrapper"
            onClick={() => this.save(false)}
          >
            <span className="draftbutton-save">
              <DoneAllIcon />
              <span className="draft-option1">Save</span>
            </span>
          </div>
        ) : this.props.extraTimeDataReducer.isdraft ? (
          <div
            className="draftbutton-innerwrapper"
            onClick={() => this.save(true)}
          >
            <span className="draftbutton">
              <Done />
              <span className="draft-option" style={{ marginLeft: 8 }}>
                Save As Draft
              </span>
            </span>
          </div>
        ) : (
          <div
            className="draftbutton-innerwrapper"
            onClick={() => this.save(false)}
          >
            <span className="draftbutton-save">
              <DoneAllIcon />
              <span className="draft-option1">Save</span>
            </span>
          </div>
        )}
      </div> */}
      </div>
    );
  };

  _renderView = (isversions) => (
    // console.log('isversions: ', isversions);
    <Grid container>
      <Grid item xs={12} md={12} sm={12}>
        <Preview onRef={() => {}} />
        {this.state.editPre && !isversions ? (
          <div>
            <div className="deletebutton-wrapper">
              {this.state.permissions.editable ? (
                <div className="deletebutton-innerwrapper">
                  <span className="deletebutton1">
                    <span className="delete-option">
                      <span
                        style={{ float: "left", margin: "0px 8px 0px 4px" }}
                      >
                        Are you sure?
                      </span>
                      <span
                        className="cursurpointer"
                        onClick={() => this._onDelete()}
                      >
                        <svg
                          className="message-edit cursour-pointer save-icon"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="#fff"
                            d="M9 16.2l-3.5-3.5c-.39-.39-1.01-.39-1.4 0-.39.39-.39 1.01 0 1.4l4.19 4.19c.39.39 1.02.39 1.41 0L20.3 7.7c.39-.39.39-1.01 0-1.4-.39-.39-1.01-.39-1.4 0L9 16.2z"
                          ></path>
                        </svg>
                      </span>
                      <span
                        className="cursurpointer"
                        onClick={() => this.cancel()}
                      >
                        <svg
                          className="message-edit cursour-pointer close-icon"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          onClick={() => this.cancel()}
                        >
                          <path
                            fill="#fff"
                            d="M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z"
                          ></path>
                        </svg>
                      </span>
                    </span>
                    <svg
                      className="delete-svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path fill="none" d="M0 0h24v24H0V0z" />
                      <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4h-3.5z" />
                    </svg>
                  </span>
                </div>
              ) : (
                ""
              )}
            </div>
            <div className="draftbutton-wrapper">
              <div
                className="draftclosebutton cursour-pointer"
                onClick={() => this.cancel()}
              >
                <span className="floatleft" style={{ marginLeft: 6 }}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                    <path d="M0 0h24v24H0z" fill="none" />
                  </svg>
                </span>
                <span className="draftclosebutton-text">Close</span>
              </div>
              {this.state.permissions.editable ? (
                <div
                  className="draftbutton-innerwrapper cursour-pointer"
                  onClick={() => this.EditPreview()}
                >
                  <span className="editbutton">
                    <span className="edit-option">Edit &nbsp; &nbsp;</span>
                    <svg width="24" height="24" viewBox="0 0 24 24">
                      <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
                      <path d="M0 0h24v24H0z" fill="none" />
                    </svg>
                  </span>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        ) : (
          <div className="draftbutton-wrapper">
            <div
              className="draftclosebutton cursour-pointer"
              onClick={() => this.cancel()}
            >
              <span className="floatleft" style={{ marginLeft: 6 }}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                  <path d="M0 0h24v24H0z" fill="none" />
                </svg>
              </span>
              <span className="draftclosebutton-text">Close</span>
            </div>
          </div>
        )}
      </Grid>
    </Grid>
  );

  onVersionChange = (parentid) => {
    const { match } = this.props;
    this.setState({ parentid }, () => {
      this.props.history.push(`${match.path}/versions`);
      this.props.GetAllExtraTime(
        `attendance/extratimebyparentid/${this.state.parentid}`,
      );
    });
  };

  _renderCreate = () => (
    <CreateComp
      text={this.getText()}
      heading={
        this.state.value == 0 ? "Concept of Extra Time" : "No drafts saved"
      }
      onCreate={this._onCreate}
      imageSrc={this.state.value == 0 ? CreateExtraTimeImage : emptylist}
      permissions={this.state.permissions}
    />
  );

  EditPreview = () => {
    this.props.history.push(`${this.props.match.path}/create`);
  };

  onEdit = (row, editPre) => {
    this.setState({ editPre });
    const { extraTimeDataReducer } = this.props;
    instance
      .get(`/attendance/extratimepolicy/${row.extratimepolicyid}`)
      .then((result) => {
        // this.props.enqueueSnackbar("Saved", { variant: 'success' })
        // this.props.CommonReducerAction(ReducersTypes.CLEAREXTRATIMEDATA)
        // extraTimeDataReducer = result.data.result
        let extratime = [];
        const data = result.data.result;
        const work = data.extratime.find((extra) => extra.extratimetypeid == 1);
        const nonwork = data.extratime.find(
          (extra) => extra.extratimetypeid == 2,
        );
        extratime = [work, nonwork];
        data.extratime = extratime;
        this.props.ExtraTimeData({ ...extraTimeDataReducer, ...data });
        // this.props.history.push(`${this.props.match.path}/view`);
        if (this.props.location.pathname.includes("/versions")) {
          this.props.history.push(`${this.props.match.path}/versions/view`);
        } else {
          this.props.history.push(`${this.props.match.path}/view`);
        }
        if (this.state.value == 0) {
          this.setState({
            completed: {
              0: true,
              1: true,
              2: true,
              3: true,
              4: true,
            },
            activeStep: 0,
          });
        } else {
          this.setState({
            completed: { 0: true, 1: true, 2: true },
            activeStep: 0,
          });
        }
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  };

  showLoader() {
    return <div className="pre-loader">Loading...</div>;
  }

  _renderList = () => {
    const { EXTRA_TIME } = this.props;

    return (
      <List
        list={EXTRA_TIME.Data}
        headers={this.state.headers}
        headerIndex={0}
        onCreate={this._onCreate}
        onVersionChange={this.onVersionChange}
        onEdit={this.onEdit}
        module={"Extra Time"}
        goTo={this.props.goTo}
        sortOrder="desc"
        permissions={this.state.permissions}
      />
    );
  };

  _renderTab = () => (
    <Grid container>
      <Grid item xs={12} md={12} sm={12}>
        <div
          position="static"
          color="default"
          className="bottom-border dashboard-tab-width"
        >
          <Grid container>
            <Grid item xs={12} md={12} sm={12}>
              {this._renderList()}
            </Grid>
          </Grid>
        </div>
      </Grid>
    </Grid>
  );

  _renderVersion = () => (
    <Grid container>
      <Grid item xs={12} md={12} sm={12}>
        {this._renderList()}
      </Grid>
    </Grid>
  );

  _renderComponent = () => {
    const { EXTRA_TIME } = this.props;

    return (
      <div className="content-outer-wrapper-with-tab">
        {EXTRA_TIME.Data.length == 0 && !EXTRA_TIME.IsPending ? (
          <div className="margin-top-20">{this._renderCreate()}</div>
        ) : (
          this._renderTab()
        )}
      </div>
    );
  };

  render() {
    const { classes, match } = this.props;

    return (
      <IntlProvider locale="en" messages={"en"}>
        <div className="innerwrapper-full-width">
          <Helmet>
            <title>{headersList.Config.ExtraTime.header}</title>
          </Helmet>
          {this.state.permissiondenied ? (
            <div className="position-rel">
              <PermissionDeniedComp />
            </div>
          ) : (
            <div>
              {(this.props.history.location.pathname ===
                "/config/track/attendance/extra_time/list" ||
                this.props.history.location.pathname ===
                  "/config/track/attendance/extra_time") && (
                <div className="common-menubar-header">
                  <Tabs
                    value={this.state.value}
                    onChange={this.handleChange.bind(this)}
                    indicatorColor="#fff"
                    textColor="primary"
                    scrollButtons="auto"
                  >
                    <Tab
                      label={
                        <FormattedMessage
                          id="LbActive"
                          defaultMessage="Active"
                        />
                      }
                      className={`tabheading ${
                        this.state.value == 0 ? "active-tab1" : "inactive-tab1"
                      } `}
                    />
                    <Tab
                      label={
                        <FormattedMessage id="LbDraft" defaultMessage="Draft" />
                      }
                      className={`tabheading ${
                        this.state.value == 1 ? "active-tab1" : "inactive-tab1"
                      } `}
                    />
                  </Tabs>
                  <div className="tab-border"></div>
                </div>
              )}

              <div className={classes.root}>
                <Grid item xs={12} md={12} sm={12}>
                  <div className="shiftplanner-forms">
                    <Switch>
                      <Route
                        exact
                        path={`${match.path}/create`}
                        render={this._renderForm}
                      />
                      <Route
                        exact
                        path={`${match.path}/versions`}
                        render={this._renderVersion}
                      />
                      <Route
                        exact
                        path={`${match.path}/list`}
                        render={this._renderComponent}
                      />
                      <Route
                        exact
                        path={`${match.path}/`}
                        render={this._renderComponent}
                      />
                      <Route
                        exact
                        path={`${match.path}/view`}
                        render={() => this._renderView(false)}
                      />
                      <Route
                        exact
                        path={`${match.path}/versions/view`}
                        render={() => this._renderView(true)}
                      />
                      <Route path="**" component={PageNotFound} />
                    </Switch>
                  </div>
                </Grid>
              </div>
            </div>
          )}
        </div>
      </IntlProvider>
    );
  }
}

const mapStateToProps = (state) => ({
  EXTRA_TIME: state.EXTRA_TIME,
  Language: state.LanguageAction.Language,
  extraTimeDataReducer: state.extraTimeDataReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      GetAllExtraTime: (data) => GetAllExtraTime(data),
      ExtraTimeData: (data) => ExtraTimeData(data),
      CommonReducerAction: (data) => CommonReducerAction(data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(React.memo(ExtraTime))));
